import React, { useCallback } from 'react'
import { Modal } from '@manychat/manyui'

import { ConfirmCardVerification } from 'common/billing/components/ConfirmCardVerification'
import { BillingCurrency } from 'common/billing/constants/BillingCurrency'
import { promiseRender } from 'common/billing/helpers/promiseRender'
import { CancelError } from 'shared/api/lib/errors/business/local'

interface ConfirmCardVerificationModalProps {
  currency: BillingCurrency
  amount: number
}

const CANCEL_ERROR = 'Rejected card verification payment'
const MODAL_WIDTH = 640

export const [confirmCardVerification, AsyncConfirmCardVerification] = promiseRender<
  void,
  ConfirmCardVerificationModalProps
>(({ resolve, reject, ...rest }) => {
  const handleClose = useCallback(() => {
    reject(new CancelError(CANCEL_ERROR))
  }, [reject])

  return (
    <Modal open onRequestClose={handleClose} width={MODAL_WIDTH}>
      <ConfirmCardVerification
        cancelUrl="#"
        className="p-y"
        onCancel={handleClose}
        onConfirm={resolve}
        {...rest}
      />
    </Modal>
  )
})
